import React from 'react';
import { Nav, NavItem, NavLink } from 'shards-react';
import { useTranslation } from 'react-i18next';
import { RootState, useDispatch, useSelector } from '../../../redux/store';
import { setSelectedTab } from '../../../redux/slices/condition';
import { MANAGE_CONDITION_TYPES } from '../../../constants';
import type { ManageConditionType } from '../../../types/condition';

const SwitchConditionDetailType = (): React.ReactElement => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { selectedTab } = useSelector((state: RootState) => state.condition);

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // タブをクリックして通常ビューと詳細ビューを切り替えたとき
  const handleTabClick = (event: React.MouseEvent<{ id: ManageConditionType }>) => {
    // console.log(event.currentTarget.id);
    dispatch(setSelectedTab(event.currentTarget.id));
  };

  // VIEW
  // ================================================================================

  return (
    <div className="mb-2">
      <Nav tabs>
        <NavItem id={MANAGE_CONDITION_TYPES.ORDINARY} onClick={handleTabClick}>
          <NavLink active={selectedTab === MANAGE_CONDITION_TYPES.ORDINARY} href="#" className="px-4 py-2">
            {t('condition.control')}
          </NavLink>
        </NavItem>
        <NavItem id={MANAGE_CONDITION_TYPES.CUSTOMIZE} onClick={handleTabClick}>
          <NavLink active={selectedTab === MANAGE_CONDITION_TYPES.CUSTOMIZE} href="#" className="px-4 py-2">
            {t('condition.detailControl')}
          </NavLink>
        </NavItem>
      </Nav>
    </div>
  );
};

export default SwitchConditionDetailType;
